<template>
    <div class="papsi-wrapper">
        <div class="papsi-wrapper flex justify-between">
            <div>
                <h1 class="text-2xl font-semibold text-[#24723b]">Overtime Requests</h1>
                <p class="text-xs text-[#747474] mt-2">Home / Overtime Requests</p>
            </div>
            <div>
                <button  class="py-3 px-5 rounded-md text-sm mr-5 w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]" @click="activeBtn = 'Button1'" v-bind:class="{active: activeBtn === 'Button1', notactive: activeBtn != 'Button1'}">Overtime Status</button>
                <button  class="py-3 px-5 rounded-md text-sm  w-[200px] shadow-lg font-semibold border border-[#a8a7a7] hover:bg-[#444]"     @click="activeBtn = 'Button2'" v-bind:class="{active: activeBtn === 'Button2', notactive: activeBtn != 'Button2'}">Noted Requests</button>
            </div>
        </div>
    </div>
    <div class="mt-11">
        <div v-if="activeBtn === 'Button1'" class="grid grid-cols-11 w-full gap-3 mb-5 ">
            <input type="text" @input="isTyping = true" placeholder="Search" class="col-span-3 border-[#b7b8b7] border p-2 px-5 rounded-md  outline-none  text-[#535353] text-sm" v-model="search">
            <select @change="consiFilter" class="w-[250px] border-[#b7b8b7] border  rounded-md   outline-none p-2 px-5  text-[#535353]  text-xs font-semibold" v-model="filtered">
                <option value="R">FOR RECOMMENDATION</option>
                <option value="P">FOR APPROVAL</option>
                <option value="A">APPROVED</option>
                <option value="D">DISAPPROVED</option>
                <option value="ALL">ALL</option>
            </select>
        </div>
        <div class="mt-8 bg-[#f0f0f0] border-[#ffffff41] border-[3px] p-3 rounded-md shadow">
            <TableControl v-if="activeBtn === 'Button1'" :Action="true" :header="header" :column="column" :info="overtimeData" :VButton="true" :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                
            <TableControl v-if="activeBtn === 'Button2'" :Action="true" :header="notedheader" :column="notedcolumn" :info="ovetimenoted" :VButton="true"  :EButton="false" :DButton="false" @EditButton="EditButton" @DeleteButton="DeleteButton" @ViewButton="ViewButton"/>                
        </div>
    </div>

    <div v-if="overtimeModal">
        <OvertimeFormModal @CloseLeave="overtimeModal = false" @cancel="overtimeModal = false" :Data="overtimeDataEmp"
            @approve="noteOvertime"  :Approval="true" />
    </div>

    <PromptComponent v-if="prompt" :header="promptheader" :header1="promptheader1" :success="success" @close="prompt = false"/>

</template>

<script>
import { defineComponent } from 'vue';
import TableControl from '.././TableControl/TableControl.vue'
import Overtime from '../../../services/overtime' 
import OvertimeFormModal from '../modal/OvertimeFormModal.vue';
import PromptComponent from '@/componentsv1/Prompt/PromptComponent.vue';

export default defineComponent({
    components:{
        TableControl,
        OvertimeFormModal,
        PromptComponent
    },
    data(){
        return{
            filtered:'ALL',
            overtimeModal: false,
            activeBtn : 'Button1',
            header: [
                { title: 'Reference No.' },
                { title: 'Name' },
                { title: 'Date Submmitted' },
                { title: 'Status' },
                { title: 'Action' },
            ],
            column:[
                'reference',
                'employee_key',
                'submit_date',
                'ot_status',
            ],
            notedheader: [
                { title: 'Reference No.' },
                { title: 'Name' },
                { title: 'Date Submmitted' },
                { title: 'Noted By' },
                { title: 'Action' },
            ],
             notedcolumn:[
                'reference',
                'employee_key',
                'submit_date',
                'noted_employee_key',
            ],
            overtimeData : null,
            overtimelist : null,
            ovetimenoted : null,
            overtimeDataEmp: null,
            overtimeDataAll: null,
            promptheader:null,
            promptheader1:null,
            success:true,
            prompt: false,
            search:'',
        }
    },
    mounted(){
        this.listOvertime()
    },
    methods:{
        async listOvertime(){
            this.$emit("showLoader")
            let that = this
            await Overtime.listOvertime().then(function(response){
                that.overtimelist = response.data.data 

            })
            this.$emit("hideLoader")

            this.filterOvertime()
        },
        consiFilter(){
            if(this.filtered == 'ALL' ){
                this.overtimeData = this.overtimeDataAll
                return
            }
            this.overtimeData = this.overtimeDataAll.filter(status=>status.ot_status == this.filtered)

        },
        filterOvertime(){
            this.overtimeData     = this.overtimelist.filter(overtime =>overtime.noted_employee_key == null)
            this.overtimeDataAll  = this.overtimeData
            this.ovetimenoted     = this.overtimelist.filter(overtime =>overtime.noted_employee_key != null)
        },
        ViewButton(data){
            this.overtimeDataEmp = data
            this.overtimeModal = true
        },
        async noteOvertime(ot_key, employee_key){
            this.$emit("showLoader")
            let that = this
            await Overtime.noteOvertime(ot_key, employee_key).then(async function(){
                that.success = true
                that.promptheader = "Overtime Request Successfully Noted"
                that.promptheader1 = "The employee will receive a notification and an email that HR has noted their request."
                that.overtimeModal = false
                await that.listOvertime()
                that.prompt = true
            }).catch(function(error){
                that.success = false
                that.promptheader  = "Error"
                that.promptheader1 = error.response.data.message
                that.prompt = true
            });

            this.$emit("hideLoader")
        }
    } 
})


</script>

<style scoped>
.active {
    color: #ffffff;
    background-color: #24723b;
  }
  .notactive {
    background-color: #CCAF12;
    color: #ececec;
  }
</style>